import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Routers from "./routers";
import Main from "./components/main";
import SixLinkButtonsPage from "./components/pages/Institutions/index";

function App() {
  return (
    <Router>
      <Main>
        <Routers />
      </Main>
      {/* <SixLinkButtonsPage/> */}
    </Router>
  );
}

export default App;
